import { convertWindBearing16 } from '../../utils/convert-wind-bearing';
import { convertSpeedUnitToWindRunUnit } from '../../utils/formatters';

export function getParametersData(parameterIds, units, formatters) {
	return [
		{
			id: parameterIds.HIGHEST_HIGH_TEMPERATURE,
			field: 'highTemperature',
			unit: '°' + units.temperature,
			formatter: formatters.temperature,
			label: 'Highest temperatures',
			description: 'Highest daily maximum temperatures.'
		},
		{
			id: parameterIds.LOWEST_LOW_TEMPERATURE,
			field: 'lowTemperature',
			unit: '°' + units.temperature,
			formatter: formatters.temperature,
			label: 'Lowest temperatures',
			description: 'Lowest daily minimum temperatures.'
		},
		{
			id: parameterIds.HIGHEST_MEAN_TEMPERATURE,
			field: 'avgTemperature',
			unit: '°' + units.temperature,
			formatter: formatters.temperature,
			label: 'Warmest days',
			description: 'Highest daily mean temperatures. This is the average of all temperature observations during a day, taken every 1 minute.'
		},
		{
			id: parameterIds.LOWEST_MEAN_TEMPERATURE,
			field: 'avgTemperature',
			unit: '°' + units.temperature,
			formatter: formatters.temperature,
			label: 'Coolest days',
			description: 'Lowest daily mean temperatures. This is the average of all temperature observations during a day, taken every 1 minute.'
		},
		{
			id: parameterIds.LOWEST_HIGH_TEMPERATURE,
			field: 'highTemperature',
			unit: '°' + units.temperature,
			formatter: formatters.temperature,
			label: 'Lowest daily highs',
			description: 'Lowest daily maximum temperatures.'
		},
		{
			id: parameterIds.HIGHEST_LOW_TEMPERATURE,
			field: 'lowTemperature',
			unit: '°' + units.temperature,
			formatter: formatters.temperature,
			label: 'Highest daily lows',
			description: 'Highest daily minimum temperatures.'
		},
		{
			id: parameterIds.LARGEST_TEMPERATURE_RANGE,
			field: 'temperatureRange',
			unit: '°' + units.temperature,
			formatter: formatters.temperatureInterval,
			label: 'Largest daily ranges',
			description: 'Largest daily temperature ranges.'
		},
		{
			id: parameterIds.SMALLEST_TEMPERATURE_RANGE,
			field: 'temperatureRange',
			unit: '°' + units.temperature,
			formatter: formatters.temperatureInterval,
			label: 'Smallest daily ranges',
			description: 'Smallest daily temperature ranges.'
		},
		{
			id: parameterIds.HIGHEST_RAINFALL,
			field: 'rainfall',
			unit: units.rain,
			formatter: formatters.rainfall,
			label: 'Wettest days',
			description: 'Highest daily rainfall totals.'
		},
		{
			id: parameterIds.HIGHEST_HOURLY_RAINFALL,
			field: 'highHourlyRain',
			unit: units.rain,
			formatter: formatters.rainfall,
			label: 'Highest hourly rainfall',
			description: 'Highest 1 hour rainfall totals. Note that the list may contain two entries for a single rain event if the event occurs close to midnight.'
		},
		{
			id: parameterIds.HIGHEST_RAIN_RATE,
			field: 'highRainRate',
			unit: units.rain + '/hr',
			formatter: formatters.rainRate,
			label: 'Highest rain rates',
			description: 'Highest instantaneous rainfall rates.'
		},
		{
			id: parameterIds.HIGHEST_WIND_GUST,
			field: 'highWindGust',
			additionalColumns: [
				{
					field: 'highWindGustBearing',
					label: 'Direction',
					formatter: b => convertWindBearing16(b)
				}
			],
			unit: units.speed,
			formatter: formatters.windGust,
			label: 'Highest wind gusts',
			description: 'Highest wind gusts.'
		},
		{
			id: parameterIds.HIGHEST_WIND_RUN,
			field: 'windRun',
			unit: convertSpeedUnitToWindRunUnit(units.speed),
			formatter: formatters.windRun,
			label: 'Highest wind runs',
			description: 'Highest daily wind runs. Think of wind run as the distance the wind would have travelled over the course of a day. It gives a measure of overall windiness.'
		},
		{
			id: parameterIds.HIGHEST_PRESSURE,
			field: 'highPressure',
			unit: units.pressure,
			formatter: formatters.pressure,
			label: 'Highest pressures',
			description: 'Highest atmospheric pressure readings.'
		},
		{
			id: parameterIds.LOWEST_PRESSURE,
			field: 'lowPressure',
			unit: units.pressure,
			formatter: formatters.pressure,
			label: 'Lowest pressures',
			description: 'Lowest atmospheric pressure readings.'
		},
		{
			id: parameterIds.HIGHEST_DEWPOINT,
			field: 'highDewpoint',
			unit: '°' + units.temperature,
			formatter: formatters.temperature,
			label: 'Highest dewpoints',
			description: 'Highest daily maximum dewpoints.'
		},
		{
			id: parameterIds.LOWEST_DEWPOINT,
			field: 'lowDewpoint',
			unit: '°' + units.temperature,
			formatter: formatters.temperature,
			label: 'Lowest dewpoints',
			description: 'Lowest daily minimum dewpoints.'
		},
		{
			id: parameterIds.LOWEST_HUMIDITY,
			field: 'lowHumidity',
			unit: '%',
			formatter: h => h,
			label: 'Lowest humidity',
			description: 'Lowest daily minimum humidity readings.'
		},
	];
}


// WEBPACK FOOTER //
// ./components/records-top-ten/parameters-data.js